class FetchAiCostLimits {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAiCostLimits;
